module.exports = {"select":"Выберите дату","ranges":{"today":"Сегодня","yesterday":"Вчера","Last7Days":"за 7 дней","Last30Days":"за 30 дней"}};